import Batch from '@/service/batch'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getbatchtags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.getbatchtags(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getbatchs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.getbatchs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getbatch(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.getbatch(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getsetsegmentinfo(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.getsetsegmentinfo(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addbatch(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.addbatch(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatebatch(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.updatebatch(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletebatch(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.deletebatch(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatebatcheicsfromexcel(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.updatebatcheicsfromexcel(payload), {
        type: 'info',
        success,
        fail
      })
    },
    downloadbatcheics(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.downloadbatcheics(payload), {
        type: 'file',
        success,
        fail
      })
    },
    downloadbatchtags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.downloadbatchtags(payload), {
        type: 'file',
        success,
        fail
      })
    },
    getbatcheics(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.getbatcheics(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getbatchtagscanurl(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.getbatchtagscanurl(payload), {
        type: 'info',
        success,
        fail
      })
    },
    updatebatcheics(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Batch.updatebatcheics(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
